import axios from "../helper/axiosIntance";
import { baseUrl } from "../helper/constant";
import Header from "./Header";
import EncryptDecrypt from "./EncryptDecrypt";

export default class OutstandingClaimReportServices {
  static list(params) {
    Header.setHeaders();
    return axios.post(
      `${baseUrl}/report/list-claim-report`,
      EncryptDecrypt.encrypt(params)
    );
  }
}
